export enum AsyncStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type AsyncStatusType = 'idle' | 'pending' | 'success' | 'error';

export enum ReportingStatus {
  REQUIRED = 'required',
  NOT_REQUIRED = 'not-required',
  SUBMITTED = 'submitted',
}

export type ReportingStatusType = 'required' | 'not-required' | 'submitted';

/**
 * Maximum number of transferees or transferors that can be added to a FinCEN report
 */
export const MAX_ITEMS_LIMIT = 8;
